// extracted by mini-css-extract-plugin
export default {"Title":"ListForm_Title__E6n0U","Error":"ListForm_Error__a8ODu"};